<img
  class="w-100"
  height="257"
  width="424"
  [ngSrc]="entry?.content?.teaser?.filename"
  *ngIf="entry?.content?.teaser?.filename"
/>
<div class="article-content p-3">
  <div class="d-flex flex-column gap">
    <div class="eyebrow">{{ entry.type }}</div>
    <h4 *ngIf="entry?.name">{{ entry?.name }}</h4>
    <div
      *ngIf="entry?.content?.excerpt"
      class="excerpt"
      [storyblokRichText]="entry?.content?.excerpt"
    ></div>
  </div>
  <a [storyblokLink]="entry" class="read border-bottom pb-1 fw-500"
    >Read Article</a
  >
</div>
